import { ILineItemWithOrder } from "../../interfaces/Session";
import { getDriverCount } from "../../pages/dashboard/utilities";

interface PercentageSliderProps {
  percentage: number;
  backgroundColour: string;
  count: number;
  bookings?: ILineItemWithOrder[];
}

export const PercentageSlider = ({ percentage, backgroundColour, count, bookings }: PercentageSliderProps) => {
  // If no groups/one group provided, render the original single bar
  if (!bookings || bookings.length <= 1) {
    return (
      <div className="h-4 w-full flex relative">
        <div className="absolute w-full h-full bg-gray-100 rounded-md" />
        <div
          className="text-black absolute text-right pr-2 font-medium text-xs leading-3 rounded-md"
          style={{
            width: `${Math.min(percentage, 100)}%`,
            minWidth: "5px",
            maxWidth: "100%",
            backgroundColor: backgroundColour,
            lineHeight: "16px",
          }}
        >
          {count}
        </div>
      </div>
    );
  }
  
  const gapWidthPixels = 2;
  const borderRadius = "0.375rem";
  
  const effectivePercentage = Math.min(percentage, 100);
  
  let cumulativePercentage = 0;
  const groups = bookings.map((booking, index) => {
    const driverCount = getDriverCount(booking);
    const groupPercentage = (driverCount / count) * effectivePercentage;
    const startPercentage = cumulativePercentage;
    cumulativePercentage += groupPercentage;
    
    return {
      bookingName: booking.order.customer?.first_name + " " + booking.order.customer?.last_name,
      seats: driverCount,
      startPercentage,
      widthPercentage: groupPercentage,
      index
    };
  }).filter(group => group.seats > 0);

  return (
    <div className="h-4 w-full flex relative">
      <div className="absolute w-full h-full bg-gray-100 rounded-md" />
      <div className={`absolute h-full flex gap-[${gapWidthPixels}px]`} style={{width: `${effectivePercentage}%`}}>
        {groups.map((group, index) => {
          const isLast = index === groups.length - 1;
          const isFirst = index === 0;
          
          return (
            <div
              key={index}
              title={`${group.bookingName} - ${group.seats} seat${group.seats !== 1 ? "s" : ""}`}
              className={`h-full ${isLast ? `text-right pr-2 font-medium text-xs leading-3` : ''}`}
              style={{
                flex: `${group.widthPercentage} 0 0`,
                backgroundColor: backgroundColour,
                borderRadius: `${isFirst ? `${borderRadius} 0 0 ${borderRadius}` : isLast ? `0 ${borderRadius} ${borderRadius} 0` : '0'}`,
                lineHeight: "16px",
                color: isLast ? 'black' : 'transparent',
                minWidth: "5px",
              }}
            >
              {isLast ? count : ''}
            </div>
          );
        })}
      </div>
    </div>
  );
};